<ng-container>
  <mat-toolbar color="primary" class="common-header-color">
    <img src="../../../../assets/images/CBOT header logo.png" alt="CBOT Logo">
    <span class="toolbar-spacer"></span>
    @if (isShowMenu) {
      <mat-icon (click)="openHideMenu()">menu</mat-icon>
    }
    @if (isAuthorizedUser('Product Catalog')) {
      <div  fxLayout="column" class="pr-3" style="cursor: pointer;" (click)="openNotification($event)">
        <mat-icon
          [matBadge]="(!showNotification && count) ? count < 100 ? count : '99+' : null"
        matBadgeColor="warn">notifications</mat-icon>
      </div>
    }
    @if (!isShowMenu) {
      <div class="user-details" #notificationBtn (click)="showHideUsercard($event)" #showBtn>
        <mat-icon style="padding: 0 5px">account_circle</mat-icon>
        <span>{{userInfo && userInfo.username | titlecase}}</span>
      </div>
    }
  </mat-toolbar>


  @if (showcard) {
    <div class="session-info-container" #cardModal (click)="$event.stopPropagation();">
      <mat-icon class="mat-icon-large">account_circle</mat-icon>
      <div class="user-info">
        <span class="user-name">{{userInfo && userInfo.username | titlecase}}</span>
        <span class="user-name">{{userInfo && userInfo.email}}</span>
      </div>
      <div class="sign-out-button"><button mat-flat-button color="primary" class="logout-btn" style="cursor:pointer" (click)="logout()">LOGOUT</button></div>
    </div>
  }
  @if (showNotification) {
    <app-notification-center  #notificationModal (countTrigger)="updateCount($event)"  (click)="$event.stopPropagation();"></app-notification-center>
  }
</ng-container>
